import { env } from 'env'
import { history } from 'store'
import {
	first_login,
	forgot,
	login,
	verify2faCode,
} from '../../../api/auth/email'
import { PROTOCOL_RESET } from '../protocol'
import {
	USER_ERROR,
	USER_LOGIN,
	USER_SETUP_2FA,
	USER_VERIFY_2FA,
} from './index'

export function userLogin(email, password, xThis) {
	return dispatch => {
		login(email, password)
			.then(response => {
				const {
					id,
					token,
					role,
					department,
					photo,
					theme,
					language,
					secret,
					two_factor,
				} = response.data

				localStorage.setItem('token', token)

				if (secret && two_factor) {
					dispatch({
						type: USER_SETUP_2FA,
						secret,
						two_factor,
					})
					return
				}

				if (!secret && two_factor) {
					dispatch({
						type: USER_VERIFY_2FA,
						two_factor,
					})
					return
				}

				localStorage.removeItem('protocols')
				localStorage.removeItem('filter')
				dispatch({
					type: USER_LOGIN,
					token,
					role: Number(role),
					photo,
					language,
					theme,
					id,
					isLogged: true,
					department,
				})
				dispatch({ type: PROTOCOL_RESET })
				history.push(
					env.REACT_APP_NEW_WORKFLOW === 'true'
						? '/workflow'
						: Number(role) === 6
							? '/'
							: '/chats/humano/atendimento'
				)
			})
			.catch(error => {
				const status = error?.response?.status
				if (status === 400 || status === 401) {
					if (error?.response?.data?.first_login) {
						xThis.dialogChangePass.handleClickOpen()
					} else if (error?.response?.data.warning) {
						dispatch({
							type: USER_ERROR,
							email: error?.response?.data?.warning,
							...error.response.data,
						})
					} else {
						dispatch({
							type: USER_ERROR,
							...error?.response?.data,
						})
					}
				} else {
					dispatch({
						type: USER_ERROR,
						email: 'Erro na api contate o suporte',
					})
				}
			})
	}
}

export function firstLogin(email, password, newPassword, confirmPassword) {
	return dispatch => {
		first_login(email, password, newPassword, confirmPassword)
			.then(response => {
				const { id, token, department, role, photo, theme, language } =
					response.data

				if (token) {
					localStorage.removeItem('token')
					localStorage.setItem('token', token)
					dispatch({
						type: USER_LOGIN,
						id,
						token,
						theme,
						role: Number(role),
						photo,
						language,
						department,
					})
					history.push(
						Number(role) === 3 || env.REACT_APP_NEW_WORKFLOW
							? '/workflow'
							: Number(role) === 6
								? '/'
								: '/chats/humano/atendimento'
					)
				}
			})
			.catch(error => {
				dispatch({
					type: USER_ERROR,
					...error.response.data,
				})
			})
	}
}

export function forgotPassword(email, xThis) {
	return dispatch => {
		forgot(email)
			.then(response => {
				const { enqueueSnackbar } = xThis.props
				enqueueSnackbar(response.data.message, {
					key: 'forgot',
					variant: 'success',
				})
				xThis.dialogForgot.handleClickOpen()
			})
			.catch(error => {
				const status = error.response.status
				const { email } = error.response.data
				const { warning } = error.response.data

				if (status === 400 || status === 401)
					dispatch({
						type: USER_ERROR,
						email_forgot: email ?? warning,
					})
			})
	}
}

export function verifyCode(code) {
	return dispatch => {
		verify2faCode(code)
			.then(({ data }) => {
				const { id, token, role, department, photo, theme, language } = data

				localStorage.setItem('token', token)
				localStorage.removeItem('protocols')
				localStorage.removeItem('filter')

				dispatch({
					type: USER_LOGIN,
					token,
					role: Number(role),
					photo,
					language,
					theme,
					id,
					isLogged: true,
					department,
				})
				dispatch({ type: PROTOCOL_RESET })
				history.push(
					env.REACT_APP_NEW_WORKFLOW === 'true'
						? '/workflow'
						: Number(role) === 6
							? '/'
							: '/chats/humano/atendimento'
				)
			})
			.catch(error => {
				if ([400, 401].includes(error?.response?.status)) {
					dispatch({
						type: USER_ERROR,
						twoFactorError: error?.response?.data?.error,
					})
				} else {
					dispatch({
						type: USER_ERROR,
						email: 'Erro na api contate o suporte',
					})
				}
			})
	}
}
